export enum DurationUnit {
  MINUTES = "MINUTES",
  HOURS = "HOURS",
  DAYS = "DAYS",
}

export const DurationUnitDisplay: Record<DurationUnit, string> = {
  [DurationUnit.MINUTES]: "Minutes",
  [DurationUnit.HOURS]: "Hours",
  [DurationUnit.DAYS]: "Days",
};

export enum FrequencyType {
  DONT_REPEAT = "DONT_REPEAT",
  DAILY = "DAILY",
  WEEKLY = "WEEKLY",
  MONTHLY = "MONTHLY",
  CUSTOM = "CUSTOM",
}

export const FrequencyTypeDisplay: Record<FrequencyType, string> = {
  [FrequencyType.DONT_REPEAT]: "Don't Repeat",
  [FrequencyType.DAILY]: "Daily",
  [FrequencyType.WEEKLY]: "Weekly",
  [FrequencyType.MONTHLY]: "Monthly",
  [FrequencyType.CUSTOM]: "Custom",
};

export enum Weekday {
  SUNDAY = "SUNDAY",
  MONDAY = "MONDAY",
  TUESDAY = "TUESDAY",
  WEDNESDAY = "WEDNESDAY",
  THURSDAY = "THURSDAY",
  FRIDAY = "FRIDAY",
  SATURDAY = "SATURDAY",
}

export const WeekdayDisplay: Record<Weekday, string> = {
  [Weekday.MONDAY]: "Monday",
  [Weekday.TUESDAY]: "Tuesday",
  [Weekday.WEDNESDAY]: "Wednesday",
  [Weekday.THURSDAY]: "Thursday",
  [Weekday.FRIDAY]: "Friday",
  [Weekday.SATURDAY]: "Saturday",
  [Weekday.SUNDAY]: "Sunday",
};

export enum CustomRepeatType {
  DAY = "DAY",
  WEEK = "WEEK",
  MONTH = "MONTH",
}

export enum MonthlyRepeatMode {
  DAY_OF_MONTH = "DAY_OF_MONTH",
  NTH_WEEKDAY = "NTH_WEEKDAY",
}

export enum EndType {
  NEVER = "NEVER",
  ON = "ON",
  AFTER = "AFTER",
}

export interface MaintenanceScheduleGeneralFormValues {
  name: string;
  pause_checks_during_maintenance: boolean;
  start_date?: Date;
  end_date?: Date | null;
  duration_value: number;
  duration_unit: DurationUnit;
  frequency_type: FrequencyType;
  rrule_byweekday?: string[];
  rrule_bymonthday?: number[];
  rrule_count?: number | null;
  rrule_until?: Date | null;
  rrule_interval?: number;
  custom_repeat_type?: CustomRepeatType;
  monthly_repeat_mode?: MonthlyRepeatMode;
  end_type?: EndType;
  tags: number[];
}
